import React from 'react';
import PropTypes from 'prop-types';


import * as inputConstants from '../inputConstants';
import * as textInputConstants from './textInputConstants';

import Input from '../Input';


function TextInput(props) {

    return (
        <Input
            {...props}
            autoComplete={props.autocomplete}
            maxLength={props.maxLength}
        />
    );
}


TextInput.propTypes = {
    ...Input.propTypes,
    autocomplete: PropTypes.oneOf(inputConstants.AUTOCOMPLETES),
    maxLength: PropTypes.number.isRequired
};

TextInput.defaultProps = {
    ...Input.defaultProps,
    maxLength: textInputConstants.MAX_LENGTH,
    type: textInputConstants.TYPE
};


export default TextInput;
